import { useEffect, useState } from "react";
import PageHierarchy from "../page-hierarchy/page-hierarchy";
import "./dashboard.scss";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { Avatar } from 'primereact/avatar';
import AvatarPhoto from './avatar.svg'
import { Button } from "primereact/button";
import { Chart } from "primereact/chart";
import ChartWrapper from "../chart-wrapper/chart-wrapper";
import PerProductChart, { PerProductChartType } from "../per-product-chart/per-product-chart";
import WeeklyPerProductChart from "../weekly-per-product-chart/weekly-per-product-chart";
import AvailabilityChart from "../availablility-chart/availablility-chart";
import { Calendar } from "primereact/calendar";
import { AppRoutes } from "features/authentication/types/app-routes";
import { PlanSelectorEnum } from "../shop-management/shop-management";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const dispatch: Function = useDispatch();
  const user = useSelector((state: any) => state.auth.user);
  const navigate = useNavigate();
  const selectedShop = useSelector((state: any) => state.user.selectedShop);
  const [dates, setDates] = useState(() => {
    const savedDates = localStorage.getItem(`${window.location.pathname}_dates`);
    if (savedDates) {
      const parsedDates = JSON.parse(savedDates).map((date: string) => new Date(date));
      return parsedDates;
    }
    return [new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), new Date()];
  });

  useEffect(() => {
    localStorage.setItem(`${window.location.pathname}_dates`, JSON.stringify(dates));
  }, [dates]);

  useEffect(()=>{
    const shopEntity = user.shops.find((shop: any) => shop.id === selectedShop);
    if(shopEntity?.plan !== PlanSelectorEnum.PRO){
      navigate(`${AppRoutes.CONSUMPTION}/product`)
    }
  },[user, user.shops, selectedShop])

  return (
    <div className='dashboard'>
      <PageHierarchy />
      <div className="dashboard__header">
        <Calendar 
        locale="eu"
        dateFormat="dd/mm/yy"
          value={dates} 
          onChange={(e) => {
            e.preventDefault();
            setDates(e.value);
          }} 
          selectionMode="range" 
          readOnlyInput 
          hideOnRangeSelection  
          placeholder="Select date"
        />
        <div className="dashboard__header__filters">
        </div>
      </div>
      <div className="dashboard__upper-charts">
        <ChartWrapper title="Products by Consumption" width={'55%'}>
          <PerProductChart dates={dates} type={PerProductChartType.TOP_5} />
        </ChartWrapper>
        <ChartWrapper title="Products available" width={'45%'}>
          <AvailabilityChart />
        </ChartWrapper>
      </div>
      <ChartWrapper title="Weekly Consumption per product" width={'100%'}>
        <WeeklyPerProductChart dates={dates} />
      </ChartWrapper>
    </div>
  );
};

export default Dashboard;
